import React, { useEffect, useState } from "react";
import LOGO_MTN from "./../assets/images/momo.png";
import "./../assets/css/hamburgers.css";

// icons
import DashboardCustomizeIcon from "@mui/icons-material/DashboardCustomize";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PeopleIcon from "@mui/icons-material/People";
import LogoutIcon from "@mui/icons-material/Logout";
import KeyIcon from "@mui/icons-material/Key";
import SchoolRoundedIcon from "@mui/icons-material/SchoolRounded";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import PaidIcon from "@mui/icons-material/Paid";
import AccountBalanceWalletRoundedIcon from "@mui/icons-material/AccountBalanceWalletRounded";
import EventIcon from "@mui/icons-material/Event";
import PaymentsIcon from "@mui/icons-material/Payments";
import CreditScoreIcon from "@mui/icons-material/CreditScore";
import Face4Icon from "@mui/icons-material/Face4";
import SettingsIcon from "@mui/icons-material/Settings";
import { Sidebar } from "primereact/sidebar";
import { NavLink, useLocation, useNavigate } from "react-router-dom";

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [visible, setVisible] = useState(false);
  const [menuItem, setMenuItem] = useState([]);
  const [appRoute, setAppRoute] = useState("");

  const deconnecteAdmin = () => {
    localStorage.removeItem("momo4scoohclient");
    navigate("/login");
  };

  const entite = localStorage.getItem("entiteSchool");

  const checkMenuIcon = (menu) => {
    if (menu === "Tableau de bord") {
      return <DashboardIcon />;
    } else if (menu === "Paiement") {
      return <PaidIcon />;
    } else if (menu === "Année scolaire") {
      return <EventIcon />;
    } else if (menu === "Niveau d'étude") {
      return <BusinessCenterIcon />;
    } else if (menu === "Elèves") {
      return <SchoolRoundedIcon />;
    } else if (menu === "Utilisateurs") {
      return <PeopleIcon />;
    } else if (menu === "Caissières") {
      return <Face4Icon />;
    } else if (menu === "Tarifs") {
      return <AccountBalanceWalletRoundedIcon />;
    }
  };

  useEffect(() => {
    const data = localStorage.getItem("menuListSchool");
    const menus = JSON.parse(data);
    setMenuItem(menus);
    setAppRoute(
      localStorage.getItem("entiteRoute")
        ? localStorage.getItem("entiteRoute")
        : ""
    );
  }, []);

  return (
    <div className="fixed w-full h-28 pb-3 bg-[#29668b] z-50">
      <div className="relative w-11/12 max-w-screen-2xl h-full mx-auto flex justify-between items-center">
        <div className="flex items-center gap-x-2 cursor-pointer">
          <img src={LOGO_MTN} alt="logo mtn" className="w-11 rounded-lg" />
          <span className="text-gl text-white font-bold leading-6">
            {entite}
          </span>
        </div>
        <div className="main-menu flex items-center gap-x-3 lg:gap-x-3 xl:gap-x-5 hidden lg:flex">
          <NavLink to="/entites">
            <button className="text-white text-sm flex items-center gap-x-1">
              <DashboardCustomizeIcon />
              <span>Entités</span>
            </button>
          </NavLink>
          {menuItem.map((item, index) => {
            if (item.titre) {
              return (
                <NavLink to={`/${item.lien}`} key={index}>
                  <button
                    key={index}
                    className="text-white text-sm flex items-center gap-x-1"
                  >
                    {checkMenuIcon(item.titre)}
                    <span>{item.titre}</span>
                  </button>
                </NavLink>
              );
            } else {
              return (
                <div className="dropdown dropdown-bottom dropdown-end">
                  <label
                    tabIndex={0}
                    className="text-white text-sm flex items-center gap-x-1 cursor-pointer"
                  >
                    <EventIcon />
                    Année Scolaire
                  </label>
                  <ul
                    tabIndex={0}
                    className="dropdown-content menu px-2 py-1 shadow bg-base-100 rounded-md w-52"
                  >
                    {item.map((el, index) => (
                      <NavLink to={`/${el.lien}`} key={index}>
                        <button
                          key={index}
                          className="bg-gray-50 w-full h-11 rounded-md px-3 text-black text-sm flex items-center gap-x-1 my-1"
                        >
                          {checkMenuIcon(el.titre)}
                          <span>{el.titre}</span>
                        </button>
                      </NavLink>
                    ))}
                  </ul>
                </div>
              );
            }
          })}
          <NavLink to={`/${appRoute}/entite/identifiants`}>
            <button className="text-white text-sm flex items-center gap-x-1">
              <KeyIcon />
              <span>Identifiants</span>
            </button>
          </NavLink>
          <button
            className="bg-red-500 text-white px-3 py-2 rounded-md text-sm font-medium flex items-center gap-x-2"
            onClick={deconnecteAdmin}
          >
            <LogoutIcon />
            <span className="hidden">Déconnexion</span>
          </button>
        </div>
        <button
          style={{ marginTop: "10px", padding: 0 }}
          className={
            visible
              ? "hamburger hamburger--collapse burger-btn is-active"
              : "hamburger hamburger--collapse burger-btn"
          }
          type="button"
          onClick={(e) => setVisible(true)}
        >
          <span className="hamburger-box">
            <span className="hamburger-inner"></span>
          </span>
        </button>
      </div>

      <div className="z-10 absolute bottom-0 left-0 right-0 bg-gray-mtn w-full">
        <svg
          height="19px"
          viewBox="0 0 1366 19.18"
          preserveAspectRatio="none"
          className="w-full hidden sm:block bg-jaune-mtn"
        >
          <path
            d="M683.1,18.3C386.63,18.3,129.24,10.85,0,0V19.18H1366V0C1236.66,10.84,979.37,18.3,683.1,18.3Z"
            fill="#f2F2f2"
          ></path>
        </svg>
        <svg
          viewBox="0 0 500 40"
          preserveAspectRatio="xMidYMin meet"
          className="w-full block sm:hidden bg-gray-mtn"
        >
          <path d="M0,0 Q250,80 500,0 Z" fill="#ffcc02"></path>
        </svg>
      </div>

      <Sidebar visible={visible} onHide={() => setVisible(false)}>
        <div className=" mt-10 main-menu flex flex-col items-start gap-y-8 lg:hidden">
          <NavLink to="/entites">
            <button className="text-black text-base font-bold flex items-center gap-x-1">
              <DashboardCustomizeIcon />
              <span>Entités</span>
            </button>
          </NavLink>
          {menuItem.map((item, index) => {
            if (item.titre) {
              return (
                <NavLink to={`/${item.lien}`} key={index}>
                  <button
                    key={index}
                    className="text-black text-base font-bold flex items-center gap-x-1"
                  >
                    {checkMenuIcon(item.titre)}
                    <span>{item.titre}</span>
                  </button>
                </NavLink>
              );
            } else {
              return (
                <div className="dropdown dropdown-bottom dropdown-start">
                  <label
                    tabIndex={0}
                    className="text-black text-base font-bold flex items-center gap-x-1 cursor-pointer"
                    style={
                      location.pathname === "/entite/tarifs"
                        ? { color: "#ffcb05", fontWeight: "bold" }
                        : location.pathname === "/entite/niveau-etude"
                        ? { color: "#ffcb05", fontWeight: "bold" }
                        : location.pathname === "/entite/annee-scolaire"
                        ? { color: "#ffcb05", fontWeight: "bold" }
                        : location.pathname ===
                          "/entite/tarifs/modalite-paiement"
                        ? { color: "#ffcb05", fontWeight: "bold" }
                        : { color: "black", fontWeight: "bold" }
                    }
                  >
                    <SettingsIcon />
                    Paramètres
                  </label>
                  <ul
                    tabIndex={0}
                    className="dropdown-content menu px-2 py-1 shadow bg-zinc-100 rounded-md w-72 mt-4"
                  >
                    {item.map((el, index) => (
                      <NavLink to={`/${el.lien}`} key={index}>
                        <button
                          key={index}
                          className="bg-white w-full h-11 rounded-md px-3 text-black text-sm flex items-center gap-x-1 my-1"
                        >
                          {checkMenuIcon(el.titre)}
                          <span>{el.titre}</span>
                        </button>
                      </NavLink>
                    ))}
                  </ul>
                </div>
              );
            }
          })}
          <NavLink to={`/${appRoute}/entite/identifiants`}>
            <button className="text-black text-base font-bold flex items-center gap-x-1">
              <KeyIcon />
              <span>Identifiants</span>
            </button>
          </NavLink>
          <button
            className="bg-red-500 text-white w-full px-4 py-2 rounded-md text-sm font-medium flex items-center gap-x-2"
            onClick={deconnecteAdmin}
          >
            <LogoutIcon />
            <span>Déconnexion</span>
          </button>
        </div>
      </Sidebar>
    </div>
  );
};

export default Navbar;
